export default __webpack_public_path__ + "static/media/pink-air-balloon.9c3297f8.svg";